// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-hero {
  background: linear-gradient(160deg, var(--cream-dark) 0%, var(--cream) 100%);
  padding: 190px 0 80px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgba(200,134,10,0.15);
}

.page-hero h1 {
  font-size: 3rem;
  color: var(--brown);
  margin-bottom: 16px;
}

.page-hero .badge {
  margin-bottom: 16px;
}

.page-hero p {
  color: var(--text-mid);
  font-size: 1.05rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Mission */
.mission-section {
  background: var(--white);
}

.mission-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.mission-card {
  text-align: center;
}

.mission-icon {
  font-size: 2.8rem;
  margin-bottom: 16px;
}

.mission-card h3 {
  font-size: 1.1rem;
  margin-bottom: 12px;
}

.mission-card p {
  font-size: 0.9rem;
  color: var(--text-mid);
  line-height: 1.8;
}

/* Values */
.values-section {
  background: var(--cream);
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.value-card {
  text-align: center;
}

.value-icon {
  font-size: 2.4rem;
  margin-bottom: 12px;
}

.value-card h3 {
  font-size: 1rem;
  margin-bottom: 8px;
}

.value-card p {
  font-size: 0.85rem;
  color: var(--text-mid);
  line-height: 1.7;
}

/* Timeline */
.milestones-section {
  background: var(--white);
}

.timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, var(--gold), var(--orange));
  transform: translateX(-50%);
}

.timeline-item {
  display: grid;
  grid-template-columns: 1fr 40px 1fr;
  gap: 16px;
  align-items: center;
  margin-bottom: 32px;
}

.timeline-item.left .timeline-year { order: 1; text-align: right; }
.timeline-item.left .timeline-dot  { order: 2; }
.timeline-item.left .timeline-content { order: 3; }

.timeline-item.right .timeline-year { order: 3; text-align: left; }
.timeline-item.right .timeline-dot  { order: 2; }
.timeline-item.right .timeline-content { order: 1; text-align: right; }

.timeline-year {
  font-size: 1.4rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.timeline-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  margin: 0 auto;
  box-shadow: 0 0 0 4px rgba(200,134,10,0.2);
  flex-shrink: 0;
}

.timeline-content p {
  font-size: 0.88rem;
  color: var(--text-mid);
  line-height: 1.7;
}

/* Team */
.team-section {
  background: var(--cream);
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.team-card {
  text-align: center;
}

.team-avatar {
  font-size: 3rem;
  margin-bottom: 12px;
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, rgba(200,134,10,0.1), rgba(196,72,10,0.05));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  border: 2px solid rgba(200,134,10,0.2);
}

.team-card h3 {
  font-size: 1rem;
  margin-bottom: 4px;
  color: var(--brown);
}

.team-card p {
  font-size: 0.85rem;
  color: var(--text-light);
}

/* CTA */
.about-cta {
  background: linear-gradient(160deg, var(--cream-dark), var(--cream));
  padding: 80px 0;
}

.about-cta h2 {
  font-size: 2.2rem;
  margin-bottom: 12px;
}

.about-cta p {
  color: var(--text-mid);
  max-width: 550px;
  margin: 0 auto;
  line-height: 1.8;
}

@media (max-width: 900px) {
  .mission-grid { grid-template-columns: 1fr; }
  .values-grid { grid-template-columns: repeat(2, 1fr); }
  .team-grid { grid-template-columns: repeat(2, 1fr); }

  .timeline::before { left: 20px; }

  .timeline-item {
    grid-template-columns: 40px 1fr;
    grid-template-rows: auto auto;
  }

  .timeline-item.left .timeline-year,
  .timeline-item.right .timeline-year {
    order: 1;
    grid-column: 2;
    text-align: left;
  }

  .timeline-item.left .timeline-dot,
  .timeline-item.right .timeline-dot {
    order: 0;
    grid-row: 1 / 3;
    grid-column: 1;
    margin: 0;
    align-self: start;
    margin-top: 4px;
  }

  .timeline-item.left .timeline-content,
  .timeline-item.right .timeline-content {
    order: 2;
    grid-column: 2;
    text-align: left;
  }
}

@media (max-width: 560px) {
  .page-hero h1 { font-size: 2rem; }
  .values-grid { grid-template-columns: 1fr; }
  .team-grid { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qCAAqC,QAAQ,EAAE,iBAAiB,EAAE;AAClE,qCAAqC,QAAQ,EAAE;AAC/C,wCAAwC,QAAQ,EAAE;;AAElD,sCAAsC,QAAQ,EAAE,gBAAgB,EAAE;AAClE,sCAAsC,QAAQ,EAAE;AAChD,yCAAyC,QAAQ,EAAE,iBAAiB,EAAE;;AAEtE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;EAC/D,cAAc;EACd,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,QAAQ;AACR;EACE,oEAAoE;EACpE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,eAAe,qCAAqC,EAAE;EACtD,aAAa,qCAAqC,EAAE;;EAEpD,oBAAoB,UAAU,EAAE;;EAEhC;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;;IAEE,QAAQ;IACR,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,QAAQ;IACR,eAAe;IACf,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,QAAQ;IACR,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB,eAAe,EAAE;EACjC,eAAe,0BAA0B,EAAE;EAC3C,aAAa,0BAA0B,EAAE;AAC3C","sourcesContent":[".page-hero {\n  background: linear-gradient(160deg, var(--cream-dark) 0%, var(--cream) 100%);\n  padding: 190px 0 80px;\n  text-align: center;\n  position: relative;\n  border-bottom: 1px solid rgba(200,134,10,0.15);\n}\n\n.page-hero h1 {\n  font-size: 3rem;\n  color: var(--brown);\n  margin-bottom: 16px;\n}\n\n.page-hero .badge {\n  margin-bottom: 16px;\n}\n\n.page-hero p {\n  color: var(--text-mid);\n  font-size: 1.05rem;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.8;\n}\n\n/* Mission */\n.mission-section {\n  background: var(--white);\n}\n\n.mission-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.mission-card {\n  text-align: center;\n}\n\n.mission-icon {\n  font-size: 2.8rem;\n  margin-bottom: 16px;\n}\n\n.mission-card h3 {\n  font-size: 1.1rem;\n  margin-bottom: 12px;\n}\n\n.mission-card p {\n  font-size: 0.9rem;\n  color: var(--text-mid);\n  line-height: 1.8;\n}\n\n/* Values */\n.values-section {\n  background: var(--cream);\n}\n\n.values-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n}\n\n.value-card {\n  text-align: center;\n}\n\n.value-icon {\n  font-size: 2.4rem;\n  margin-bottom: 12px;\n}\n\n.value-card h3 {\n  font-size: 1rem;\n  margin-bottom: 8px;\n}\n\n.value-card p {\n  font-size: 0.85rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n}\n\n/* Timeline */\n.milestones-section {\n  background: var(--white);\n}\n\n.timeline {\n  position: relative;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.timeline::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: linear-gradient(to bottom, var(--gold), var(--orange));\n  transform: translateX(-50%);\n}\n\n.timeline-item {\n  display: grid;\n  grid-template-columns: 1fr 40px 1fr;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.timeline-item.left .timeline-year { order: 1; text-align: right; }\n.timeline-item.left .timeline-dot  { order: 2; }\n.timeline-item.left .timeline-content { order: 3; }\n\n.timeline-item.right .timeline-year { order: 3; text-align: left; }\n.timeline-item.right .timeline-dot  { order: 2; }\n.timeline-item.right .timeline-content { order: 1; text-align: right; }\n\n.timeline-year {\n  font-size: 1.4rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.timeline-dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  margin: 0 auto;\n  box-shadow: 0 0 0 4px rgba(200,134,10,0.2);\n  flex-shrink: 0;\n}\n\n.timeline-content p {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n}\n\n/* Team */\n.team-section {\n  background: var(--cream);\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.team-card {\n  text-align: center;\n}\n\n.team-avatar {\n  font-size: 3rem;\n  margin-bottom: 12px;\n  width: 72px;\n  height: 72px;\n  background: linear-gradient(135deg, rgba(200,134,10,0.1), rgba(196,72,10,0.05));\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  border: 2px solid rgba(200,134,10,0.2);\n}\n\n.team-card h3 {\n  font-size: 1rem;\n  margin-bottom: 4px;\n  color: var(--brown);\n}\n\n.team-card p {\n  font-size: 0.85rem;\n  color: var(--text-light);\n}\n\n/* CTA */\n.about-cta {\n  background: linear-gradient(160deg, var(--cream-dark), var(--cream));\n  padding: 80px 0;\n}\n\n.about-cta h2 {\n  font-size: 2.2rem;\n  margin-bottom: 12px;\n}\n\n.about-cta p {\n  color: var(--text-mid);\n  max-width: 550px;\n  margin: 0 auto;\n  line-height: 1.8;\n}\n\n@media (max-width: 900px) {\n  .mission-grid { grid-template-columns: 1fr; }\n  .values-grid { grid-template-columns: repeat(2, 1fr); }\n  .team-grid { grid-template-columns: repeat(2, 1fr); }\n\n  .timeline::before { left: 20px; }\n\n  .timeline-item {\n    grid-template-columns: 40px 1fr;\n    grid-template-rows: auto auto;\n  }\n\n  .timeline-item.left .timeline-year,\n  .timeline-item.right .timeline-year {\n    order: 1;\n    grid-column: 2;\n    text-align: left;\n  }\n\n  .timeline-item.left .timeline-dot,\n  .timeline-item.right .timeline-dot {\n    order: 0;\n    grid-row: 1 / 3;\n    grid-column: 1;\n    margin: 0;\n    align-self: start;\n    margin-top: 4px;\n  }\n\n  .timeline-item.left .timeline-content,\n  .timeline-item.right .timeline-content {\n    order: 2;\n    grid-column: 2;\n    text-align: left;\n  }\n}\n\n@media (max-width: 560px) {\n  .page-hero h1 { font-size: 2rem; }\n  .values-grid { grid-template-columns: 1fr; }\n  .team-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
